import {
  LF_TOGGLE_SHOW_LINES,
  LF_TOGGLE_SHOW_BACKGROUND,
  LF_TOGGLE_SHOW_CONTROLS,
  LF_TOGGLE_DRAW_IN_PROGRESS,
  LF_TOGGLE_DRAW_FINISHED,
  LF_SET_NEXT_PATH_INDEX,
  LF_RESET_PATH_INDEX,
  LF_ENABLE_CONTINUOUS_DRAW,
  LF_CLEAR_ALL_PATHS,
  LF_AUDIO_DOWNLOAD_REQUEST,
  LF_AUDIO_DOWNLOAD_RESPONSE,
  LF_SHOW_START_BUTTON,
} from '../action-types/draw-stage';

const initialState = {
  currentPathIndex: -1,
  drawFinished: false,
  showControls: false,
  showBackground: true,
  showLines: true,
  drawInProgress: false,
  audioLoading: false,
  showStartButton: false,
};

export default function drawStage(state = initialState, action) {
  switch (action.type) {
    case LF_TOGGLE_SHOW_LINES: {
      let nextState = {};

      if (state.showBackground) {
        nextState = { showLines: !state.showLines };
      } else {
        nextState = {
          showBackground: true,
          showLines: false,
        };
      }

      return Object.assign({}, state, nextState);
    }

    case LF_TOGGLE_SHOW_BACKGROUND: {
      let nextState = {};

      if (state.showLines) {
        nextState = { showBackground: !state.showBackground };
      } else {
        nextState = {
          showBackground: false,
          showLines: true,
        };
      }

      return Object.assign({}, state, nextState);
    }

    case LF_TOGGLE_SHOW_CONTROLS: {
      return Object.assign({}, state, {
        showControls: action.show,
      });
    }

    case LF_SET_NEXT_PATH_INDEX: {
      return Object.assign({}, state, {
        currentPathIndex: state.currentPathIndex + 1,
      });
    }

    case LF_TOGGLE_DRAW_IN_PROGRESS: {
      return Object.assign({}, state, {
        drawInProgress: action.inProgress,
      });
    }

    case LF_RESET_PATH_INDEX: {
      return Object.assign({}, state, {
        currentPathIndex: -1,
      });
    }

    case LF_TOGGLE_DRAW_FINISHED: {
      return Object.assign({}, state, {
        drawFinished: action.finished,
      });
    }

    case LF_ENABLE_CONTINUOUS_DRAW: {
      // We use Infinity because all we want is to have
      // a unique value for Continuous Draw, which will
      // be interpreted by the DrawStage Component;
      // working with concrete guideline indexes (length)
      // would only complicate things, and bring nothing
      // useful to the table.

      return Object.assign({}, state, {
        currentPathIndex: Infinity,
      });
    }

    case LF_CLEAR_ALL_PATHS: {
      return Object.assign({}, state, {
        currentPathIndex: -1,
        drawInProgress: false,
        drawFinished: false,
      });
    }

    case LF_AUDIO_DOWNLOAD_REQUEST: {
      return Object.assign({}, state, {
        audioLoading: true,
      });
    }

    case LF_AUDIO_DOWNLOAD_RESPONSE: {
      return Object.assign({}, state, {
        audioLoading: false,
      });
    }
    case LF_SHOW_START_BUTTON: {
      return Object.assign({}, state, {
        showStartButton: action.show,
      });
    }

    default: {
      return state;
    }
  }
}
